// ============================================
// bindOnce
// 同じ要素へのイベント二重登録を防ぐための共通ユーティリティ。
// data-{key}-bound 属性を立て、初回だけ true を返す（2回目以降は false）。
//
// 使い方:
//   nodes.forEach((node) => {
//     if (!bindOnce(node, 'smoothScroll')) return;
//     node.addEventListener('click', handler);
//   });
// ============================================
export function bindOnce(el, key) {
  const flag = `${key}Bound`;
  if (el.dataset[flag] === '1') return false;
  el.dataset[flag] = '1';
  return true;
}
